<template>
  <section class="sceduler">
    <!-- <button class="cancel" @click.stop="$emit('cancel')">
      <svg width="1em" height="1em" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 1L8 8" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M1 8L8 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
      <span>Cancel</span>
    </button> -->
    <!-- <div class="name">{{ itemName }}</div> -->
    <div class="dinner-slot">
      <slot> </slot>
    </div>
    <ul class="list">
      <li class="list-option" v-for="(option, index) in options" :key="index">
        <button
          class="option"
          :class="{
            selected: option.selected,
            disabled: option.disabled,
            flexible: option.flexible,
            available: option.available,
            recommended: option.recommended,
          }"
          :disabled="option.disabled"
          @click="$emit('reschedule', {timeslot: option.timeslot, event: $event})"
        >
          <CalendarIcon class="calendar-icon" />
          <span class="option-name" v-html="option.name"></span>
          <span class="option-description">
            <span :class="{loading: isLoading}">{{ option.description }}</span>
          </span>
        </button>
      </li>
    </ul>
    <slot name="actions"> </slot>
  </section>
</template>

<script>
import {getNextDay} from './utils';
import CalendarIcon from '@components/svg/calendar.vue';

export default {
  name: 'SchedulePopover',
  components: {
    CalendarIcon,
  },
  props: {
    timeslots: {
      type: Array,
      default: () => [],
    },
    activity: Object,
    isLoading: {
      type: Boolean,
      default: true,
    },
    solutionDates: {
      type: Array,
      default: () => [],
    },
    selectedDayLabel: String,
    recommendedDayLabel: String,
  },
  computed: {
    itemName() {
      if (!this.activity) {
        return 'Restaurant Press';
      }
      return (this.activity.name || '').replace('LUNCH:', '').replace('BREAKFAST:', '').replace('DINNER:', '').trim();
    },
    options() {
      if (!this.activity) {
        return [];
      }

      const activityDesctiprion = (this.activity.explanations || []).join(', ');
      const days = this.solutionDates.map((x) => {
        const dayStart = x.date.valueOf();
        const dayEnd = getNextDay(x.date).valueOf();

        const isAvailble = this.timeslots.find((y) => {
          const s = y[0] * 1000;
          const e = y[1] * 1000;
          return (dayStart <= s && dayEnd > s) || (dayStart <= e && dayEnd > e);
        });
        const availabilityLabel = isAvailble ? 'Available' : 'Place is unavailable or doesn’t fit on this day';
        const isSelected = this.selectedDayLabel === x.label;
        const isRecommended = this.recommendedDayLabel === x.label;
        const description = isSelected || isRecommended ? activityDesctiprion : availabilityLabel;
        return {
          name: `<b>${x.label}</b> ${x.description}`,
          // name: `${x.description}`,
          description: this.isLoading ? '' : description,
          selected: isSelected,
          disabled: !isSelected && !isAvailble && !isRecommended,
          available: isAvailble,
          flexible: false,
          timeslot: isAvailble,
          recommended: isRecommended,
        };
      });
      // return [flexibleOption, ...days];
      return days;
    },
  },
};
</script>

<style scoped>
.sceduler {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 33px rgba(0, 0, 0, 0.13);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
}

.name {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
  padding: 16px;
  text-align: left;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  overflow: auto;
  flex: 1;
}

.list-option {
  list-style: 0;
}

.option {
  display: block;
  padding: 16px;
  border: none;
  appearance: none;
  background: none;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;
  position: relative;
  width: 100%;
  text-align: left;
}

.option:hover {
  background-color: #ededed;
}

.option.disabled {
  cursor: default;
  background: none;
}

.option:before {
  content: '';
  position: absolute;
  /* background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='2' fill='%232C6FC7'/%3E%3Cpath d='M5 7.71429L7.18182 10L11 6' stroke='white' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A"); */
  background-repeat: no-repeat;
  width: 16px;
  height: 16px;
  left: 16px;
  top: 15px;
}

.option.flexible:before {
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='2' fill='%23E9A43D'/%3E%3Cpath d='M10.9501 11L11.3187 10.2629C11.5122 9.87583 11.8261 9.56195 12.2132 9.36842L12.9501 9L12.2131 8.63145C11.826 8.43793 11.5122 8.1241 11.3187 7.73707L10.9501 7L10.5816 7.73709C10.3881 8.12411 10.0742 8.43793 9.68723 8.63145L8.9502 9L9.6871 9.36842C10.0742 9.56195 10.3881 9.87582 10.5816 10.2629L10.9501 11Z' fill='white'/%3E%3Cpath d='M5.9502 10L6.65199 8.59633C6.84551 8.20925 7.15938 7.89538 7.54646 7.70185L8.9502 7L7.54646 6.29815C7.15938 6.10462 6.84551 5.79075 6.65199 5.40367L5.9502 4L5.24828 5.40376C5.05475 5.79079 4.74092 6.10461 4.35389 6.29813L2.9502 7L4.35389 7.70187C4.74092 7.89539 5.05475 8.20921 5.24828 8.59624L5.9502 10Z' fill='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  left: 16px;
  top: 15px;
}
.option.flexible.available:after {
  content: '';
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 1.30078V6.29983H11.9991' stroke='%23E9A43D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M7 11.2988L7 6.29978L2.00095 6.29978' stroke='%23E9A43D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  right: 16px;
  top: 15px;
  width: 16px;
  height: 16px;
}
.option.available:after {
  content: '';
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 9.07104C17.5 13.7655 13.6944 17.571 9 17.571C4.30558 17.571 0.5 13.7655 0.5 9.07104C0.5 4.37662 4.30558 0.571045 9 0.571045C13.6944 0.571045 17.5 4.37662 17.5 9.07104Z' fill='%23E6E6E6' stroke='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  right: 16px;
  top: 15px;
  width: 16px;
  height: 16px;
}
.option.selected:after {
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='17' height='17' viewBox='0 0 19 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.5 9.07104C17.5 13.7655 13.6944 17.571 9 17.571C4.30558 17.571 0.5 13.7655 0.5 9.07104C0.5 4.37662 4.30558 0.571045 9 0.571045C13.6944 0.571045 17.5 4.37662 17.5 9.07104Z' fill='%232C70C9' stroke='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M13.5495 5.81212C13.9009 6.11942 13.9466 6.66527 13.6516 7.03133L9.46704 12.2236C9.3092 12.4195 9.07627 12.5326 8.83076 12.5326C8.58527 12.5326 8.35234 12.4195 8.19449 12.2236L5.73296 9.16932C5.43795 8.80329 5.48367 8.25742 5.83508 7.95012C6.18648 7.64282 6.71051 7.69046 7.00551 8.05649L8.83076 10.3213L12.3791 5.91849C12.6741 5.55244 13.1981 5.50482 13.5495 5.81212Z' fill='white'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  right: 16px;
  top: 15px;
  width: 16px;
  height: 16px;
}
.option.recommended:before {
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='13' viewBox='0 0 14 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M7 1.30078V6.29983H11.9991' stroke='%23E9A43D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M7 11.2988L7 6.29978L2.00095 6.29978' stroke='%23E9A43D' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  left: 16px;
  top: 15px;
}
/* .option.disabled:before {
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='16' height='16' rx='2' fill='%23DFDFDF' /%3E%3Csvg x='3.5' y='3.5' width='7' height='8' viewBox='0 0 7 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1.01172 6.54785L6.28635 1.27322' stroke='%23B6B6B6' stroke-linecap='round' stroke-linejoin='round' /%3E%3Cpath d='M1.01172 1.27344L6.28635 6.54807' stroke='%23B6B6B6' stroke-linecap='round' stroke-linejoin='round' /%3E%3C/svg%3E%3C/svg%3E%0A");
  background-repeat: no-repeat;
  left: 16px;
  top: 15px;
} */

/* .option.selected .option-name:before {
  content: 'Selected ';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #e9a43d;
} */

.option.recommended .option-name:before {
  content: 'Recommended ';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #e9a43d;
}

.option.recommended .calendar-icon {
  color: #e9a43d;
}

.option.selected .calendar-icon {
  color: #e9a43d;
}

.option.disabled .calendar-icon {
  color: var(--toneAlert-100);
}

.option-name {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: #071d3b;
  display: block;
  padding: 0 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.option-description {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 118.14%;
  letter-spacing: -0.005em;
  color: rgba(7, 29, 59, 0.41);
  display: block;
  padding: 0 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cancel {
  border: none;
  padding: 10px;
  appearance: none;
  background: transparent;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
  font-size: var(--schedule-popover-cancel-btn-fs, inherit);
  color: #c1c1c1;
}

.cancel > span {
  font-size: 0;
}

.dinner-slot {
  margin-top: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.calendar-icon {
  position: absolute;
  left: 16px;
  top: 16px;
  color: var(toneTDark);
}
</style>

<style scoped>
.loading {
  position: absolute;
  background-color: #e2e2e2;
  overflow: hidden;
  border-radius: 10px;
  min-height: 1em;
  display: block;
  width: calc(100% - 60px);
}

.loading::after {
  display: block;
  content: '';
  position: absolute;
  top: 0;
  width: 25%;
  height: 100%;
  will-change: transform;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: loading 1.5s infinite;
}

@keyframes loading {
  100% {
    transform: translateX(400%);
  }
}
</style>
